import { api } from './client';

/** Gastos y APIs (solo OWNER). Prefijo: /api/owner/gastos */

export interface GastoFijo {
  nombre: string;
  usdMes: number;
}

export interface GastosConfig {
  cobroMensualUsd: number | null;
  fijos: GastoFijo[];
}

export interface ServicioExterno {
  nombre: string;
  tipo: string;
  estado: 'ok' | 'apagada' | 'error';
  detalle: string;
  ultimoUsoAt: string | null;
}

export interface PanelGastos {
  config: GastosConfig;
  ia: { usd: number; turnosApi: number; usosCli: number; modelosSinPrecio: string[] };
  cuenta: {
    fijosUsd: number;
    iaUsd: number;
    totalUsd: number;
    gananciaUsd: number | null;
    margenPct: number | null;
  };
  servicios: ServicioExterno[];
}

export const getGastos = () => api.get<PanelGastos>('/api/owner/gastos');

export const putGastos = (config: GastosConfig) =>
  api.put<GastosConfig>('/api/owner/gastos', config);

/** Consumo REAL (solo OWNER): IA de Anthropic, servidor en vivo y mensajes. */
export interface ConsumoReal {
  desde: string;
  hasta: string;
  hayClaveAdmin: boolean;
  ia: {
    estado: 'ok' | 'sin_clave_admin' | 'sin_clave_ia' | 'clave_no_encontrada' | 'error';
    detalle?: string;
    clave?: { id: string; nombre: string; espacio: string | null; espacioPropio: boolean };
    origenDolares?: 'factura' | 'tokens × precio';
    dias: Array<{ dia: string; usd: number; entrada: number; salida: number; cacheLeida: number; cacheEscrita: number }>;
    total: { usd: number; entrada: number; salida: number; cacheLeida: number; cacheEscrita: number; porModelo: Array<{ modelo: string; usd: number; tokens: number }> };
    anotadoPorElSistemaUsd?: number;
  };
  servidor: {
    estado: 'ok' | 'sin_datos' | 'viejo';
    medidoEn?: string;
    servidor?: { nombre: string; plan: string | null; precioMes: number | null; moneda: string | null; origenPrecio: string | null; cpus: number; memoriaMb: number; memoriaUsadaMb: number; discoGb: number; discoUsadoGb: number; carga1m: number };
    contenedores?: Array<{ nombre: string; cpuPct: number; memoriaMb: number; memoriaLimiteMb: number | null }>;
    proyecto?: { cpuPct: number; memoriaMb: number; discoMb: number | null; partePct: number; costoMes: number | null };
    historial?: Array<{ t: string; cpuPct: number; memoriaMb: number }>;
  };
  mensajes: {
    total: { entraron: number; ia: number; personas: number; sistema: number; chatsNuevos: number };
    porCanal: Array<{ canal: string; entraron: number; ia: number; personas: number }>;
    dias: Array<{ dia: string; entraron: number; ia: number; personas: number }>;
  };
}

export const getConsumoReal = () => api.get<ConsumoReal>('/api/owner/consumo-real');

export const putClaveAdmin = (clave: string) =>
  api.put<{ organizacion: string | null }>('/api/owner/consumo-real/clave-admin', { clave });
